import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { AwsRdsEngine } from '../models/AwsRdsEngine';
import { RestoreRdsInstanceClasses } from '../models/RestoreRdsInstanceClasses';

/**
 * no description
 */
export class ListAwsRdsInstanceClassesApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Gets available RDS instance classes for the engine in the region
   * @param engine 
   * @param engineVersion 
   * @param accountId ID of the restore account
   * @param region The region to get instance classes for
   * @param projectId The project ID
   */
  public async listAwsRdsInstanceClasses(engine: AwsRdsEngine, engineVersion: string, accountId: string, region: string, projectId: string, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'engine' is not null or undefined
    if (engine === null || engine === undefined) {
      throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "engine");
    }


    // verify required parameter 'engineVersion' is not null or undefined
    if (engineVersion === null || engineVersion === undefined) {
      throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "engineVersion");
    }


    // verify required parameter 'accountId' is not null or undefined
    if (accountId === null || accountId === undefined) {
      throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "accountId");
    }


    // verify required parameter 'region' is not null or undefined
    if (region === null || region === undefined) {
      throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "region");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ListAwsRdsInstanceClassesApi", "listAwsRdsInstanceClasses", "projectId");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/restore-accounts/{accountId}/regions/{region}/aws-rds-instance-classes'
      .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
      .replace('{' + 'region' + '}', encodeURIComponent(String(region)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

    // Query Params
    if (engine !== undefined) {
      requestContext.setQueryParam("engine", ObjectSerializer.serialize(engine, "AwsRdsEngine", ""));
    }

    // Query Params
    if (engineVersion !== undefined) {
      requestContext.setQueryParam("engineVersion", ObjectSerializer.serialize(engineVersion, "string", "tobedefined"));
    }


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ListAwsRdsInstanceClassesApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to listAwsRdsInstanceClasses
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async listAwsRdsInstanceClassesWithHttpInfo(response: ResponseContext): Promise<HttpInfo<RestoreRdsInstanceClasses >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: RestoreRdsInstanceClasses = ObjectSerializer.deserialize(
        await response.body.json(),
        "RestoreRdsInstanceClasses", ""
      ) as RestoreRdsInstanceClasses;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: RestoreRdsInstanceClasses = await response.body.json() as RestoreRdsInstanceClasses;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
